
/**
 * @export
 * @enum {string}
 */
export enum UserState {
    LICENSED = 'LICENSED',
    MOBILE = 'MOBILE',
    NO_ACCESS = 'NO_ACCESS',
    DISABLED = 'DISABLED',
    CRM_ONLY = 'CRM_ONLY',
    CONFERENCE = 'CONFERENCE',
    CREDIT_ALERTS = 'CREDIT_ALERTS'
}